import { statItems } from '@/mocks/home';

export default function StatStrip() {
  return (
    <section className="w-full bg-primary-500">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-6 px-4 py-10 md:grid-cols-4 md:px-6 md:py-12">
        {statItems.map((item) => (
          <div key={item.label} className="flex items-center gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-background-50/15 text-background-50 dark:text-foreground-950">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <div>
              <div className="font-heading text-xl font-black text-background-50 md:text-2xl dark:text-foreground-950">
                {item.value}
              </div>
              <div className="mt-1 text-xs text-background-50/80 dark:text-foreground-950/80">{item.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}